<nz-transfer [style]="customStyle" [nzDataSource]="dataSource" [nzDisabled]="disabled || false" [nzTitles]="titles"
  [nzListStyle]="listStyle" [nzOperations]="operations" [nzItemUnit]="itemUnit" [nzItemsUnit]="itemsUnit"
  [nzRenderList]="renderList" [nzFooter]="footer" [nzShowSearch]="showSearch" [nzFilterOption]="filterOption"
  [nzSearchPlaceholder]="searchPlaceholder || 'Search'" [nzNotFoundContent]="notFoundContent"
  [nzSelectedKeys]="selectedKeys" [nzTargetKeys]="targetKeys" (nzSearchChange)="searchChange($event)"
  (nzSelectChange)="selectOrigin($event)" (nzChange)="changeOrigin($event)">
  <ng-content></ng-content>
</nz-transfer>
